import { makeStyles } from 'tss-react/mui';

import { Breakpoint } from '@constants/common/ui.constants';

const useStyles = makeStyles()((theme) => ({
  tag: {
    padding: '4px 8px',
    borderRadius: theme.borderRadius.sm,
    background: theme.secondary.s5,

    [theme.breakpoints.down(Breakpoint.Sm)]: {
      alignSelf: 'end',
    },
  },
}));

export default useStyles;
